module.exports = __webpack_public_path__ + "static/media/heading-bg.73323826.png";